import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@ngneat/transloco';

@Pipe({
  name: 'localeToLanguage',
  pure: true
})
export class LocaleToLanguagePipe implements PipeTransform {

  constructor() {
  }

  /**
   *
   * @param value: string
   *
   */
  transform(
    value: string
  ): string {
    switch (value) {
      case 'en':
        return translate('Anglais');
        break;
      case 'it':
        return translate('Italien');
        break;
      case 'es':
        return translate('Espagnol');
        break;
      case 'de':
        return translate('Allemand');
        break;
      case 'fr':
        return translate('Francais');
        break;
      default:
        return translate('Anglais');
    }
  }
}
